import { Flex, Spin } from 'antd';

const Loading = () => {
  return (
    <Flex align="center" justify="center" className="host-h-[100vh]">
      <Spin />
    </Flex>
  );
};

export default Loading;
